const nativeReplaceStateGlobalKey = "__kwNativeHistoryReplaceState"
const suppressHistoryPublishGlobalKey = "__kwSuppressHistoryPublish"

const getSuppressCount = () => {
  const raw = (window as unknown as Record<string, unknown>)[suppressHistoryPublishGlobalKey]

  return typeof raw === "number" && Number.isFinite(raw) ? raw : 0
}

const setSuppressCount = (value: number) => {
  ;(window as unknown as Record<string, number>)[suppressHistoryPublishGlobalKey] = Math.max(
    0,
    value,
  )
}

const withSuppressedHistoryPublish = (callback: () => void) => {
  const previous = getSuppressCount()
  setSuppressCount(previous + 1)
  try {
    callback()
  } finally {
    setSuppressCount(previous)
  }
}

export const replaceUrlWithoutRoutePublish = (nextUrl: string) => {
  if (typeof window === "undefined") return

  const exposedReplaceState = (
    window as unknown as Record<string, History["replaceState"] | undefined>
  )[nativeReplaceStateGlobalKey]
  const replaceState = exposedReplaceState ?? window.history.replaceState
  withSuppressedHistoryPublish(() => {
    Reflect.apply(replaceState, window.history, [window.history.state, document.title, nextUrl])
  })
}
